import { render, staticRenderFns } from "./ReportesRips.vue?vue&type=template&id=f6345a1a"
import script from "./ReportesRips.vue?vue&type=script&lang=js"
export * from "./ReportesRips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports